import {
    Controller,
    Helper,
    Instance,
    Knot,
    State,
    Table,
    TabPanel,
} from '@siposdani87/sui-js';
import { app } from '../app';

import { AssetService } from '@services/assetService';
import { LanguageService } from '@services/languageService';
import { SiteService } from '@services/siteService';
import { initTable } from '@utils/collectionSetup';

export class SitePoliciesController extends Controller {
    static readonly inject = [
        'instances',
        'siteService',
        'languageService',
        'assetService',
    ] as const;

    tabPanel!: TabPanel;
    activeTab!: string;
    dom: Knot;
    state: State;
    helper: Helper;

    private cookiesTable!: Table;
    private personalDataTable!: Table;
    private softwareDataTable!: Table;

    constructor(
        instances: Instance,
        private siteService: SiteService,
        private languageService: LanguageService,
        private assetService: AssetService,
    ) {
        super();

        this.dom = instances.dom;
        this.state = instances.state;
        this.helper = instances.helper;
    }

    enter(): void {
        this._initLayout();
    }

    protected _initLayout(): void {
        this._initToolbarButtons();
        this._initTabPanel('terms-of-service');

        this._initCookieTable();
        this._initPersonalDataTable();
        this._initSoftwareDataTable();
    }

    private _initSoftwareDataTable(): void {
        this.softwareDataTable = initTable(
            this.softwareDataTable,
            this.dom,
            '.software-data-table',
            null,
            {
                entityKey: 'software_data',
                fetchData: () => this.siteService.getSoftwareData(),
            },
            undefined,
            undefined,
            undefined,
            {
                no_content: {
                    image_url: this.assetService.getPath(
                        'images/others/no-content.png',
                    ),
                    text: this.languageService.translate('text.no_content'),
                },
                sort: {
                    column: 'id',
                    order: 'asc',
                },
                row_count: 12,
                columns: ['id', 'goal', 'claim'],
            },
        ) as Table;
    }

    private _initPersonalDataTable(): void {
        this.personalDataTable = initTable(
            this.personalDataTable,
            this.dom,
            '.personal-data-table',
            null,
            {
                entityKey: 'personal_data',
                fetchData: () => this.siteService.getPersonalData(),
            },
            undefined,
            undefined,
            undefined,
            {
                no_content: {
                    image_url: this.assetService.getPath(
                        'images/others/no-content.png',
                    ),
                    text: this.languageService.translate('text.no_content'),
                },
                sort: {
                    column: 'id',
                    order: 'asc',
                },
                row_count: 12,
                columns: ['id', 'goal', 'claim'],
            },
        ) as Table;
    }

    private _initCookieTable(): void {
        this.cookiesTable = initTable(
            this.cookiesTable,
            this.dom,
            '.cookies-table',
            null,
            {
                entityKey: 'cookies',
                fetchData: () => this.siteService.getCookies(),
            },
            undefined,
            undefined,
            undefined,
            {
                no_content: {
                    image_url: this.assetService.getPath(
                        'images/others/no-content.png',
                    ),
                    text: this.languageService.translate('text.no_content'),
                },
                sort: {
                    column: 'id',
                    order: 'asc',
                },
                row_count: 12,
                columns: ['id', 'expires', 'desc'],
            },
        ) as Table;
    }

    private _initToolbarButtons(): void {
        this.helper.iconButton('.btn-landing-page', this.dom, () => {
            this.state.goBack('site.landing-page');
        });
    }

    private _initTabPanel(defaultTab: string): void {
        const tabParam = this.state.getParam('tab', defaultTab);
        this.tabPanel = new TabPanel(this.dom, '.tab-panel', tabParam);
        this.tabPanel.on('change', (tab) => {
            this.activeTab = tab;
            this.state.setParam('tab', tab);
        });
        this.activeTab = this.tabPanel.getActive();
    }
}

export const sitePoliciesController = app.controller(
    'sitePoliciesController',
    SitePoliciesController,
);
